import React from 'react';
import { useParams } from 'react-router-dom';
import FormDisplay from '../components/FormDisplay';
import { bodyMuted, glow, pageBg } from '@/components/ui/design';

export default function FormScreen() {
  const { formId } = useParams<{ formId: string }>();

  if (!formId) {
    return (
      <div className={`relative isolate min-h-screen overflow-hidden flex items-center justify-center px-4 ${pageBg}`}>
        <div className={glow} />
        <div className="text-center">
          <div className="text-6xl mb-6">❌</div>
          <h2 className="mb-6 text-[clamp(40px,6.5vw,88px)] font-bold leading-[0.95] tracking-[-0.05em] text-grey10 dark:text-white">Invalid Form Link</h2>
          <p className={bodyMuted}>The form link you followed is not valid.</p>
        </div>
      </div>
    );
  }

  const handleFormSubmit = (submission: any) => {
    console.log('Form submission received:', submission);
    // TODO: Send to backend API
  };

  return (
    <div className={`min-h-screen py-8 sm:py-12 ${pageBg}`}>
      <FormDisplay 
        formId={formId} 
        onSubmit={handleFormSubmit}
      />
    </div>
  );
}


